<template>
  <div class="good-shop">
    <!-- 买过的店 -->
    <div v-if="popTags.length" class="good-tags">
      <tag
        v-for="(promote, index) in popTags"
        :key="index"
        has-border
        :has-background="!!promote.backgroundColor"
        :primary-color="promote.textColor"
        :secondary-color="promote.frameColor"
        :corner-radius="promote.cornerRadius"
        :bg-color="promote.backgroundColor"
      >
        {{ promote.tag }}
      </tag>
    </div>
    <div @click.stop="gotoShop">
      <span class="shop-name">{{ popShortName }}</span>
      <span>进店</span>
      <IconFont name="mc-icon-arrowright" size="8px" />
    </div>
  </div>
</template>

<script>
import Tag from '@/common/widgets/good_tag'
export default {
  components: {
    Tag
  },
  props: {
    popTags: {
      type: Array,
      default: () => []
    },
    popShortName: {
      type: String,
      default: ''
    },
    popUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    gotoShop() {
      if (this.popUrl !== '') {
        this.$emit('beforeGotoShop')
        this.$autoRedirect(this.popUrl)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.good-shop {
  display: flex;

  height: 0.4rem;
  margin-top: 0.08rem;

  font-size: 0.26rem;
  line-height: 0.36rem;
  color: #8c8c8c;
  .good-tags {
    height: 0.4rem;

    @include flex(row, normal, center);
  }
  .shop-name {
    margin-right: 0.14rem;
  }
}
</style>
